import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-952267a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-header" }
const _hoisted_2 = { class: "live-header__date" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["data-date"]
const _hoisted_5 = ["data-id", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "live-item__dot-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "live-item__dot" }),
  /*#__PURE__*/_createElementVNode("span", { class: "live-item__line" })
], -1))
const _hoisted_7 = { class: "live-item__content" }
const _hoisted_8 = { class: "live-item__time" }
const _hoisted_9 = { class: "live-item__title" }
const _hoisted_10 = {
  key: 1,
  class: "live-loading"
}
const _hoisted_11 = {
  key: 2,
  class: "live-no-more"
}
const _hoisted_12 = {
  key: 3,
  class: "live-empty"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "live-detail" }

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import NewsDetail from './NewsDetail.vue'
import { useRoute } from 'vue-router'
import infoApi from '@/api/info'
import { zh_tran, objTran } from '@/utils/lang.js'

// ─── Props ────────────────────────────────────────────────────────────────────
interface ImgItem {
  url: string
  width: number
  height: number
  id: number
  newsId: number
}

interface StockInfo {
  id: number
  symbol: string
  name: string
  fluctuation_range: number
  exchange: string
  market: string
  lastPrice: number | null
  newsId: number
}

interface LiveItem {
  id: number
  decryptId: string
  title: string
  introduction: string
  source: string
  bigImg: string
  imgs: ImgItem[]
  columnCode: string
  columnName: string
  createTime: number
  createTimeFormat: string
  publishTime: number
  timestamp: number
  stockInfo: StockInfo[]
  articleInfo: {
    type: string
    data: { url: string }
  }
}

// ─── 列表状态 ─────────────────────────────────────────────────────────────────

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveFeed',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isDark: boolean
}



// ─── 繁体支持 ─────────────────────────────────────────────────────────────────
const route = useRoute()
const lang = (route.query['Accept-Language'] as string) || 'zh-Hans'
const isTraditional = computed(() => lang === 'zh-Hant')

function tran(text: string): string {
  if (!text) return text
  if (isTraditional.value) return (text as any).tran()
  return text
}

onMounted(async () => {
  if (isTraditional.value) zh_tran('t')
  await fetchList(true)

  // 处理路由参数 selectedId
  const routeSelectedId = route.query.selectedId
  if (routeSelectedId) {
    const targetId = Number(routeSelectedId)
    const target = list.value.find(item => item.id === targetId)
    if (target) {
      selectArticle(target)
      await nextTick()
      const el = listRef.value?.querySelector(`[data-id="${targetId}"]`) as HTMLElement
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    } else if (list.value.length > 0) {
      // selectedId 在列表中找不到，fallback 到第一条
      selectArticle(list.value[0])
    }
  } else if (list.value.length > 0) {
    // 没有路由参数，默认选中第一条
    selectArticle(list.value[0])
  }

  countdown.value = REFRESH_INTERVAL  // 初始化秒数
  startCountdown()
})

// ─── 类型定义 ─────────────────────────────────────────────────────────────────
const list = ref<LiveItem[]>([])
const loading = ref(false)
const noMore = ref(false)
const PAGE_SIZE = 100
const timestamp = ref(0)

// 待应用的新内容（静默拉取后暂存）
const pendingNewList = ref<LiveItem[]>([])
const hasNewContent = ref(false)

const selectedId = ref<number | null>(null)
const selectedDecryptId = ref<string | null>(null)
// 从当前列表中实时读取 createTimeFormat，确保列表刷新后自动同步
const selectedCreateTimeFormat = computed(() => {
  if (!selectedId.value) return ''
  const item = list.value.find(i => i.id === selectedId.value)
  return item?.createTimeFormat || ''
})
const listRef = ref<HTMLElement | null>(null)

// ─── 今日标题 ─────────────────────────────────────────────────────────────────
const WEEK_DAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
const todayLabel = computed(() => {
  const now = new Date()
  const m = now.getMonth() + 1
  const d = now.getDate()
  const w = WEEK_DAYS[now.getDay()]
  return `今日(${m}月${d}日 ${w})`
})

// ─── 自动刷新 + 倒计时 ────────────────────────────────────────────────────────
const REFRESH_INTERVAL = 60
const autoRefresh = ref(true)
const countdown = ref(REFRESH_INTERVAL)
const refreshing = ref(false)  // 手动刷新加载中状态

let countdownTimer: ReturnType<typeof setInterval> | null = null

function startCountdown() {
  stopCountdown()
  // 不重置 countdown，从当前值继续（恢复时保留秒数）
  countdownTimer = setInterval(() => {
    if (!autoRefresh.value) return
    countdown.value--
    if (countdown.value <= 0) {
      // 倒计时结束，静默检测新内容
      checkNewContent()
      countdown.value = REFRESH_INTERVAL
    }
  }, 1000)
}

function stopCountdown() {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
}

// 监听勾选状态：勾选时从当前秒数继续，取消时暂停（保留秒数）
watch(autoRefresh, (val) => {
  if (val) {
    startCountdown()
  } else {
    stopCountdown()
    // 不重置 countdown，保留当前秒数
  }
})

// 手动刷新：直接刷新列表，显示加载中
async function doRefresh() {
  refreshing.value = true
  try {
    await fetchList(true)
  } finally {
    refreshing.value = false
  }
}

// ─── 请求 ─────────────────────────────────────────────────────────────────────
function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    clientType: 'h5',
    'Accept-Language': lang,
  }
}

/** 静默拉取最新一页，对比当前列表第一条 id，有新内容则显示提示 */
async function checkNewContent() {
  try {
    const res: any = await infoApi.discoverNews({
      data: {
        pageSize: PAGE_SIZE,
        specialCode: '7x24',
        type: 1,
        timestamp: Math.floor(Date.now() / 1000),
      },
      headers: buildHeaders(),
    })
    const raw: any[] = res?.data || []
    if (!raw.length) return
    const items: LiveItem[] = isTraditional.value ? objTran('t', raw) : raw
    const normalized = items.map((item) => ({ ...item, id: Number(item.id) }))

    // 对比：新数据第一条 id 与当前列表第一条 id 不同，说明有新内容
    const currentFirstId = list.value[0]?.id ?? null
    const newFirstId = normalized[0]?.id ?? null
    if (newFirstId !== null && newFirstId !== currentFirstId) {
      pendingNewList.value = normalized
      hasNewContent.value = true
    }
  } catch (e) {
    console.error('[LiveFeed] checkNewContent error', e)
  }
}

/** 点击"目前已有新内容，单击查看"后应用新数据 */
async function applyNewContent() {
  if (!pendingNewList.value.length) return
  hasNewContent.value = false

  const prevId = selectedId.value
  list.value = pendingNewList.value
  pendingNewList.value = []
  noMore.value = false

  // 更新分页时间戳为新列表最后一条的 timestamp
  const last = list.value[list.value.length - 1]
  if (last) {
    timestamp.value = last.timestamp || 0
  }

  // 保持选中项，找不到则选第一条
  const stillExists = list.value.some((item) => item.id === prevId)
  if (!stillExists && list.value.length > 0) {
    selectArticle(list.value[0])
  }

  // 滚到顶部
  await nextTick()
  if (listRef.value) listRef.value.scrollTop = 0
}

async function fetchList(reset = false) {
  if (loading.value || (!reset && noMore.value)) return
  loading.value = true
  try {
    // 首次加载：用当前时间戳；加载更多：用上一批最后一条的 timestamp
    const timestamps = reset
      ? Math.floor(Date.now() / 1000)
      : timestamp.value

    const res: any = await infoApi.discoverNews({
      data: {
        pageSize: PAGE_SIZE,
        specialCode: '7x24',
        type: 1,
        timestamp: timestamps,
      },
      headers: buildHeaders(),
    })

    const raw: any[] = res?.data || []
    const items: LiveItem[] = raw.map((item: any) => item)
    const converted: LiveItem[] = isTraditional.value ? objTran('t', items) : items
    // 统一将 id 转为 number，防止接口返回字符串导致 === 比较失败
    const normalized = converted.map((item) => ({ ...item, id: Number(item.id) }))

    if (reset) {
      const prevId = selectedId.value
      list.value = normalized
      noMore.value = false
      // 重置时清除新内容提示
      hasNewContent.value = false
      pendingNewList.value = []
      const stillExists = normalized.some((item) => item.id === prevId)
      if (stillExists) {
        // 原来选中的还在，保持不变
      } else if (normalized.length > 0) {
        selectArticle(normalized[0])
      } else {
        selectedId.value = null
        selectedDecryptId.value = null
      }
    } else {
      list.value = list.value.concat(normalized)
    }

    // 用本批最后一条的 timestamp 字段作为下次加载更多的游标
    if (normalized.length > 0) {
      const last = normalized[normalized.length - 1]
      timestamp.value = last.timestamp || 0
    }

    if (normalized.length < PAGE_SIZE) noMore.value = true
  } catch (e) {
    console.error('[LiveFeed] fetchList error', e)
  } finally {
    loading.value = false
  }
}

function selectArticle(item: LiveItem) {
  selectedId.value = Number(item.id)
  selectedDecryptId.value = item.decryptId || null
}

// ─── 滚动时更新顶部日期标签 ──────────────────────────────────────────────────
const stickyDateLabel = ref('')

function updateStickyDate() {
  const el = listRef.value
  if (!el) return
  const scrollTop = el.scrollTop
  // scrollTop 接近 0 时恢复今日标签
  if (scrollTop < 10) {
    stickyDateLabel.value = ''
    return
  }
  // 找所有日期分隔行，取最后一个 offsetTop <= scrollTop + header高度 的
  const dividers = el.querySelectorAll<HTMLElement>('.live-date-divider')
  let matched = ''
  dividers.forEach((d) => {
    if (d.offsetTop <= scrollTop + 50) {
      matched = d.dataset.date || ''
    }
  })
  if (matched) {
    // 根据 date key 生成标签
    const parts = matched.split('-')
    if (parts.length === 3) {
      const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
      const pad = (n: number) => String(n).padStart(2, '0')
      stickyDateLabel.value = `${pad(d.getMonth() + 1)}月${pad(d.getDate())}日 ${WEEK_DAYS[d.getDay()]}`
    }
  } else {
    stickyDateLabel.value = ''
  }
}

// ─── 滚动加载 ─────────────────────────────────────────────────────────────────
function onScroll() {
  const el = listRef.value
  if (!el) return
  updateStickyDate()
  const { scrollTop, scrollHeight, clientHeight } = el
  if (scrollHeight - scrollTop - clientHeight < 80) fetchList()
}

// ─── 工具函数 ─────────────────────────────────────────────────────────────────
function formatHM(val: number | string | undefined): string {
  if (!val) return ''
  const d = typeof val === 'number'
    ? new Date(val > 1e10 ? val : val * 1000)
    : new Date(val)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** 获取列表项的日期 key（YYYY-MM-DD） */
function getItemDateKey(item: LiveItem): string {
  const ts = item.publishTime || item.createTime
  if (!ts) return ''
  const d = new Date(ts > 1e10 ? ts : ts * 1000)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** 获取列表项的日期分隔标签（MM月DD日 周X） */
function getItemDateLabel(item: LiveItem): string {
  const ts = item.publishTime || item.createTime
  if (!ts) return ''
  const d = new Date(ts > 1e10 ? ts : ts * 1000)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  const m = pad(d.getMonth() + 1)
  const day = pad(d.getDate())
  const w = WEEK_DAYS[d.getDay()]
  return `${m}月${day}日 ${w}`
}

/** 是否需要在该条前插入日期分隔行 */
function shouldShowDateDivider(item: LiveItem, index: number): boolean {
  const key = getItemDateKey(item)
  if (!key) return false

  // 今天不插入（顶部 header 已有今日标签）
  const now = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  const todayKey = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
  if (key === todayKey) return false

  // 第一条非今天：插入
  if (index === 0) return true

  // 与上一条不同天：插入
  const prevKey = getItemDateKey(list.value[index - 1])
  return key !== prevKey
}

onUnmounted(() => {
  stopCountdown()
})

return (_ctx: any,_cache: any) => {
  const _directive_heightoverflowtitle = _resolveDirective("heightoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["live-feed", __props.isDark ? 'dark' : 'light'])
  }, [
    _createElementVNode("div", {
      class: "live-list",
      ref_key: "listRef",
      ref: listRef,
      onScroll: onScroll
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(tran(stickyDateLabel.value || _unref(todayLabel))), 1),
        _createElementVNode("label", {
          class: _normalizeClass(["live-header__auto", { paused: !autoRefresh.value }])
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((autoRefresh).value = $event))
          }, null, 512), [
            [_vModelCheckbox, autoRefresh.value]
          ]),
          _createElementVNode("span", null, _toDisplayString(countdown.value) + "s" + _toDisplayString(autoRefresh.value ? tran('后自动刷新') : tran('已暂停')), 1)
        ], 2),
        _createElementVNode("span", {
          class: "live-header__refresh",
          onClick: doRefresh,
          title: tran('刷新')
        }, "↻", 8, _hoisted_3)
      ]),
      (hasNewContent.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "live-new-tip",
            onClick: applyNewContent
          }, _toDisplayString(tran('已有新内容，点击查看')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [
          (shouldShowDateDivider(item, index))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["live-date-divider", { 'live-date-divider--hidden': stickyDateLabel.value && getItemDateLabel(item) === stickyDateLabel.value }]),
                "data-date": getItemDateKey(item)
              }, _toDisplayString(tran(getItemDateLabel(item))), 11, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            "data-id": item.id,
            class: _normalizeClass(["live-item", { active: selectedId.value === item.id }]),
            onClick: ($event: any) => (selectArticle(item))
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(formatHM(item.createTime || item.publishTime)), 1),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(tran(item.title)), 1)
              ])), [
                [_directive_heightoverflowtitle, tran(item.title)]
              ])
            ])
          ], 10, _hoisted_5)
        ], 64))
      }), 128)),
      (loading.value || refreshing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(tran('加载中')) + "…", 1))
        : _createCommentVNode("", true),
      (noMore.value && list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(tran('没有更多了')), 1))
        : _createCommentVNode("", true),
      (!loading.value && !list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("img", {
              src: __props.isDark ? require('@/assets/nodata_dark_v.png') : require('@/assets/nodata_light_v.png'),
              alt: "",
              class: "live-empty__img"
            }, null, 8, _hoisted_13),
            _createElementVNode("span", null, _toDisplayString(tran('暂无数据')), 1)
          ]))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(NewsDetail, {
        "is-dark": __props.isDark,
        "news-id": selectedId.value,
        "news-decrypt-id": selectedDecryptId.value,
        "create-time-format": _unref(selectedCreateTimeFormat),
        "has-list-data": list.value.length > 0
      }, null, 8, ["is-dark", "news-id", "news-decrypt-id", "create-time-format", "has-list-data"])
    ])
  ], 2))
}
}

})